import React, { Component, Fragment } from "react";
import ScrollToTop from "react-scroll-up";
import Slider from "react-slick";
import { slideSlick } from "../page-demo/script";
import ServiceList from "../elements/service/ServiceList";
import BlogContent from "../elements/blog/BlogContent";
import Header from "../component/header/Header";
import CallAction from "../elements/callaction/CallAction";
import Accordion01 from "../elements/Accordion";
import GallerySection from "../blocks/Gallery";
import { FiCheck, FiChevronUp, FiHeadphones } from "react-icons/fi";
import Helmet from "../component/common/Helmet";
import home1 from "../assets/images/home/1.png";
import home2 from "../assets/images/home/2.png";
import home3 from "../assets/images/home/3.png";
import home4 from "../assets/images/home/4.png";
import { FaWhatsapp } from "react-icons/fa";

const SlideList = [
  {
    textPosition: "text-left",
    bgImage: home4,
    category: "",
    title: "Acar Elektrik",
    description: "İhtiyacın olan yerde, doğru elektrik çözümleri.",
    buttonText: "WhatsApp İletişim",
    buttonLink: "/contact",
  },
  {
    textPosition: "text-left",
    bgImage: home2,
    category: "",
    title: "Acar Elektrik",
    description: "Güvenli elektrik, temiz işçilik",
    buttonText: "WhatsApp İletişim",
    buttonLink: "/contact",
  },
  {
    textPosition: "text-left",
    bgImage: home3,
    category: "",
    title: "Acar Elektrik",
    description: "Küçük iş, büyük özen",
    buttonText: "WhatsApp İletişim",
    buttonLink: "/contact",
  },
];

const WHATSAPP_NUMBER = "905419252451";
const WHATSAPP_MESSAGE = "Merhaba, Acar Elektrik sitesinden size ulaşıyorum.";

class Business extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
    };
    this.openModal = this.openModal.bind(this);
  }
  openModal() {
    this.setState({ isOpen: true });
  }
  render() {
    var namesItemOne = [
      "Ev ve iş yerleri için elektrik tesisatı ve yenileme işleri",
      "Fethiye genelinde proje, kurulum ve bakım çalışmaları",
      "Güneş enerjisi ve yenilenebilir enerji sistemleri",
      "Elektrik panosu, sigorta ve altyapı düzenlemeleri",
    ];
    var namesItemTwo = [
      "Fethiye ve çevresinde birçok farklı iş tecrübesi",
      "İhtiyaca göre net ve uygulanabilir çözümler",
      "Temiz işçilik ve düzenli çalışma anlayışı",
      "İş bittikten sonra da ulaşılabilir destek",
    ];

    const PostList = BlogContent.slice(0, 3);

    return (
      <Fragment>
        <Helmet pageTitle="Business" />
        <Header />
        {/* Start Slider Area   */}
        <div className="slider-wrapper">
          <div className="slider-activation">
            <Slider className="rn-slick-dot dot-light" {...slideSlick}>
              {SlideList.map((value, index) => (
                <div
                  key={index}
                  className="slide slide-style-2 d-flex align-items-center justify-content-center position-relative"
                  style={{ minHeight: "100vh", overflow: "hidden" }}
                >
                  <img
                    src={value.bgImage}
                    alt=""
                    style={{
                      position: "absolute",
                      inset: 0,
                      width: "100%",
                      height: "100%",
                      objectFit: "cover",
                      zIndex: 1,
                    }}
                  />
                  <div
                    style={{
                      position: "absolute",
                      inset: 0,
                      backgroundColor: "rgba(0,0,0,0.6)",
                      zIndex: 2,
                    }}
                  />
                  <div
                    className="container position-relative"
                    style={{ zIndex: 3 }}
                  >
                    <div className="row">
                      <div className="col-lg-12">
                        <div className={`inner ${value.textPosition}`}>
                          <h1 className="title text-white">{value.title}</h1>
                          <p className="description text-white">
                            {value.description}
                          </p>

                          <div className="slide-btn">
                            <p>
                              <a
                                className="rn-button-style--2 btn-primary-color"
                                href="tel:+905419252451"
                              >
                                Keşif Talep Et
                              </a>
                            </p>
                            <a
                              href={`https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
                                WHATSAPP_MESSAGE,
                              )}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="rn-button-style--2 btn-solid"
                            >
                              <FaWhatsapp style={{ marginRight: "8px" }} />
                              WhatsApp İletişim
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Slider>
          </div>
        </div>
        {/* End Slider Area   */}

        {/* Start Contact Top Area  */}
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-4 col-md-6 col-sm-6 col-12 mt_mobile--50">
              <div className="rn-address text-center">
                <div className="icon">
                  <FiHeadphones />
                </div>
                <div className="inner">
                  <h4 className="title">Acar Elektrik İletişim Numarası</h4>
                  <p>
                    <a href="tel:+905419252451">+90 541 925 24 51</a>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Contact Top Area  */}
        <GallerySection />

        {/* Start Service Area  */}
        <div className="service-area creative-service-wrapper ptb--40 bg_color--1">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title service-style--3 text-center mb--30 mb_sm--0">
                  <h2 className="title">Acar Elektrik</h2>
                  <p>
                    Fethiye ve çevresinde ev ve iş yerlerine yönelik güvenli,
                    düzenli ve ihtiyaca uygun elektrik çözümleri sunuyoruz. Her
                    işi özenle planlar, temiz işçilikle teslim ederiz.
                  </p>
                </div>
              </div>
            </div>
            <div className="row creative-service">
              <div className="col-lg-12">
                <ServiceList
                  item="6"
                  column="col-lg-4 col-md-6 col-sm-6 col-12 text-left"
                />
              </div>
            </div>
          </div>
        </div>
        {/* End Service Area  */}

        {/* Start About Area  */}
        <div className="rn-about-area ptb--120 bg_color--5">
          <div className="container">
            <div className="row row--35 align-items-center">
              <div className="col-lg-6">
                <div className="thumbnail">
                  <img className="w-100" src={home1} alt="About Images" />
                </div>
              </div>
              <div className="col-lg-6">
                <div className="about-inner inner">
                  <div className="section-title">
                    <h2 className="title">Acar Elektrik</h2>
                    <p>
                      Ev ve iş yerleri için elektrik tesisatı, bakım ve
                      yenilenebilir enerji çözümlerinde ihtiyaca uygun, güvenli
                      ve düzenli hizmet sunuyoruz. Her işi temiz işçilik ve
                      doğru planlama ile tamamlamayı önemsiyoruz.
                    </p>
                  </div>
                  <div className="accordion-wrapper mt--30">
                    <Accordion01 />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End About Area  */}

        {/* Start About Area  */}
        <div className="rn-about-area ptb--120 bg_color--1">
          <div className="container">
            <div className="row row--35 align-items-center">
              <div className="col-lg-6 order-2 order-lg-1">
                <div className="about-inner inner">
                  <div className="section-title">
                    <h2 className="title">Acar Hakkında</h2>
                    <p className="description">
                      Acar Elektrik, Fethiye ve çevresinde uzun süredir ev ve iş
                      yerlerine yönelik elektrik tesisatı, bakım ve
                      yenilenebilir enerji alanlarında hizmet vermektedir.
                      Bölgede birçok farklı projede görev alarak, farklı
                      ihtiyaçlara uygun çözümler üretme tecrübesi kazandık.
                      Yaptığımız işlerde önceliğimiz; güvenli kullanım, düzenli
                      işçilik ve işi baştan doğru yapmaktır. Küçük bir arıza da
                      olsa, kapsamlı bir kurulum da olsa aynı özenle çalışır,
                      işi teslim ettikten sonra da arkasında dururuz.
                    </p>
                  </div>
                  <div className="mt--30">
                    <h4>Neler Yapıyoruz?</h4>
                    <ul className="list-style--1">
                      {namesItemOne.map((name, index) => {
                        return (
                          <li key={index}>
                            <FiCheck /> {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                  <div className="mt--30">
                    <h4>Neden Acar Elektrik?</h4>
                    <ul className="list-style--1">
                      {namesItemTwo.map((name, index) => {
                        return (
                          <li key={index}>
                            <FiCheck /> {name}
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="col-lg-6 order-1 order-lg-2">
                <div className="thumbnail position-relative">
                  <img className="w-100" src={home2} alt="About Images" />
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End About Area  */}

        {/* Start call To Action  */}
        <CallAction />
        {/* End call To Action  */}

        {/* Start Back To Top */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
        {/* End Back To Top */}
      </Fragment>
    );
  }
}
export default Business;
